const apiBaseUrl =  'https://apis.footplayhd.com'
const imageBaseurl =  'https://apis.footplayhd.com/uploads/'
const PROXYUrl = 'https://apis.footplayhd.com/stream?url=';
// const apiBaseUrl = 'http://localhost:5000'
// const imageBaseurl = 'http://localhost:5000/uploads/'
// const PROXYUrl = 'http://localhost:5000/stream?url=';

const localhostKey ={
  token:'at'
}

export const siteData = {
  name: "OG Web Guru",
}

const pageRoute = {
  login:"/login", 
  dashboard:"/dashboard", 
  blogs:"/newses", 
  channels:"/channels", 
  channelPage:"/channel/", 
  contactUs:"/contact", 
  dmca:"/dmca", 
  tournament:"/tournament/", 
  match:"/match/", 
  home:'/'
}

const getImageFullUrl =  (url)=>{
    return imageBaseurl + url
}

export{
  apiBaseUrl,imageBaseurl, localhostKey, pageRoute, getImageFullUrl, PROXYUrl
}